/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EmbeddedRequestDTO } from "../models/EmbeddedRequestDTO";
import type { EmbedParamsDTO } from "../models/EmbedParamsDTO";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class PowerBiEmbeddedService {
  /**
   * @param requestBody
   * @returns EmbedParamsDTO
   * @throws ApiError
   */
  public static powerBiEmbeddedCreateEmbeddedConfiguration(
    requestBody: EmbeddedRequestDTO
  ): CancelablePromise<EmbedParamsDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/PowerBIEmbedded/CreateEmbeddedConfiguration",
      body: requestBody,
      mediaType: "application/json",
    });
  }
}
